import ClickableListItem from 'components/Luxkit/List/ClickableListItem'
import ListItemThumbnail from 'components/Luxkit/List/ListItemThumbnail'
import ListItemLoadingSkeleton from 'components/Luxkit/List/ListItemLoadingSkeleton'
import useMerchandise from 'hooks/Merchandise/useMerchandise'
import useMerchandiseBrand from 'hooks/Merchandise/useMerchandiseBrand'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import React, { useMemo } from 'react'
import Image from 'components/Common/Image'
import ListItemPrice from 'components/Luxkit/List/ListItemPrice'
import qs from 'qs'

interface Props {
  itemId: string;
  type: 'category' | 'brand' | 'product';
}

function MerchandiseSearchFormResultItem(props: Props) {
  const { itemId, type } = props

  const [merchandise] = useMerchandise(itemId, { disabled: type !== 'product' })
  const [brand] = useMerchandiseBrand(itemId, { disabled: type !== 'brand' })
  const [category] = useMerchandiseCategory({ id: itemId }, { disabled: type !== 'category' })

  const itemData = useMemo(() => {
    switch (type) {
      case 'product':
        return {
          label: merchandise?.name,
          subtitle: merchandise?.brand.name,
          image: merchandise?.images[0],
          price: merchandise?.leadVariant.price,
          to: `/shop/offer/${merchandise?.slug}/${merchandise?.id}`,
        }
      case 'brand':
        const query = qs.stringify({
          brands: brand?.id,
        })
        return {
          label: brand?.name,
          image: brand?.logo ?? brand?.image,
          to: `/search/shop/?${query}`,
        }
      case 'category':
        return {
          label: category?.name,
          image: category?.image,
          to: `/search/shop/${category?.slug}`,
        }
    }
  }, [type, merchandise, brand, category])

  if (!itemData.label) {
    return <ListItemLoadingSkeleton
      startIcon
      subtitle={type === 'product'}
    />
  }

  return <ClickableListItem
    title={<b>{itemData.label}</b>}
    subtitle={itemData.subtitle}
    startIcon={<ListItemThumbnail>
      <Image
        fit="center"
        image={itemData.image}
        height={48}
        width={48}
      />
    </ListItemThumbnail>}
    to={itemData.to}
  >
    {!!itemData.price && <ListItemPrice
      price={itemData.price}
      label="From"
      size="small"
    />}
  </ClickableListItem>
}

export default MerchandiseSearchFormResultItem
